/**
 * DIEUKYDIEU.TV - SEARCH TEXT UTILS, HIGHLIGHTING & ROW RENDERING
 */
import { t } from '../i18n.js';
import {
    getUnifiedSearchDatabase,
    getSearchHistory,
    clearAllSearchHistory,
    removeSearchHistory,
    POPULAR_SEARCH_TOPICS,
    getFeaturedSuggestions
} from './search-db.js';
import { renderChipHTML } from '../components/index.js';
export {
    escapeHtml,
    escapeRegExp,
    removeVietnameseTones,
    highlightMatch
} from './search-text.js';
import {
    escapeHtml,
    removeVietnameseTones,
    highlightMatch
} from './search-text.js';

export function filterSearchDatabase(query, filterType = 'all') {
    if (!query || !query.trim()) return [];
    const qRaw = query.toLowerCase().trim();
    const qNorm = removeVietnameseTones(query);
    const db = getUnifiedSearchDatabase();

    return db.filter(item => {
        if (filterType !== 'all' && item.type !== filterType) return false;

        const searchRaw = item._searchRaw || `${item.title || ''} ${item.desc || ''} ${item.author || ''} ${item.tag || ''}`.toLowerCase();
        const searchNorm = item._searchNorm || removeVietnameseTones(searchRaw);

        return (
            searchRaw.includes(qRaw) || searchNorm.includes(qNorm) ||
            (qRaw === 'video' && item.type === 'video') ||
            (qRaw === 'audio' && item.type === 'audio') ||
            ((qRaw === 'bai viet' || qRaw === 'baiviet') && item.type === 'article')
        );
    });
}

export function createMediaRowHTML(item, query, isMobile = false) {
    const badgeMap = {
        video: { icon: 'play_circle', label: 'Video', class: 'badge-video' },
        audio: { icon: 'headphones', label: 'Audio', class: 'badge-audio' },
        article: { icon: 'article', label: 'Bài viết', class: 'badge-article' }
    };
    const badge = badgeMap[item.type] || badgeMap.article;

    const safeTitleAttr = escapeHtml(item.title);
    const safeImgAttr = escapeHtml(item.img);

    return `
    <div class="media-row-card" tabindex="0" role="button" aria-label="${safeTitleAttr}"
         data-search-title="${safeTitleAttr}" data-search-img="${safeImgAttr}" data-search-mobile="${isMobile}"
         onclick="handleSelectSearchResult(this)">
        <div class="media-row-thumb-box">
            <img src="${safeImgAttr}" alt="${safeTitleAttr}" class="media-row-thumb" loading="lazy"
                 onerror="this.src='https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&w=600&q=80'">
        </div>
        <div class="media-row-info">
            <div class="media-row-title">${highlightMatch(item.title, query)}</div>
            <div class="media-row-meta-row">
                <span class="media-type-badge ${badge.class}">
                    <span class="material-symbols-rounded">${badge.icon}</span>
                    ${badge.label}
                </span>
                <span class="media-meta-item">
                    <span class="material-symbols-rounded">person</span>
                    <span>${escapeHtml(item.author)}</span>
                </span>
                ${item.duration && !item.duration.includes('đọc') ? `
                <span class="media-meta-item">
                    <span class="material-symbols-rounded">schedule</span>
                    <span>${escapeHtml(item.duration)}</span>
                </span>
                ` : ''}
            </div>
        </div>
        <span class="material-symbols-rounded media-row-arrow">arrow_forward</span>
    </div>
    `;
}


export function renderSearchTopicChip(tp, isMobile = false) {
    return renderChipHTML({
        id: tp.label,
        label: tp.label,
        icon: tp.icon,
        variant: 'subchip',
        legacyClass: 'search-topic-chip',
        onClickAttr: 'applySearchQuery(this)',
        extraAttrs: `data-query="${escapeHtml(tp.label)}" data-mobile="${isMobile}"`
    });
}

export function renderFeaturedCardHTML(item, isMobile = false) {
    const badgeMap = {
        video: { icon: 'play_circle', label: t('search_filter_video'), class: 'badge-video' },
        audio: { icon: 'headphones', label: t('search_filter_audio'), class: 'badge-audio' },
        article: { icon: 'article', label: t('search_filter_articles'), class: 'badge-article' }
    };
    const badge = badgeMap[item.type] || badgeMap.article;

    return `
    <div class="ms-featured-card" data-search-title="${escapeHtml(item.title)}" data-search-img="${escapeHtml(item.img)}" data-search-mobile="${isMobile}" onclick="handleSelectSearchResult(this)">
        <div class="ms-featured-thumb-wrap">
            <img src="${escapeHtml(item.img)}" alt="" class="ms-featured-thumb" loading="lazy"
                 onerror="this.src='https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&w=600&q=80'">
        </div>
        <div class="ms-featured-info">
            <div class="ms-featured-title">${escapeHtml(item.title)}</div>
            <div class="ms-featured-meta">
                <span class="media-type-badge ${badge.class}">
                    <span class="material-symbols-rounded">${badge.icon}</span>
                    ${badge.label}
                </span>
                ${item.duration && !item.duration.includes('đọc') ? `
                <span class="media-meta-item">
                    <span class="material-symbols-rounded">schedule</span>
                    <span>${escapeHtml(item.duration)}</span>
                </span>
                ` : ''}
            </div>
        </div>
    </div>
    `.trim();
}

export function renderDesktopEmptyState(containerEl) {
    const history = getSearchHistory();
    let historySection = '';

    if (history.length > 0) {
        const historyItems = history.slice(0, 5).map(term => `
            <div class="search-history-item" data-query="${escapeHtml(term)}" data-mobile="false" onclick="applySearchQuery(this)">
                <div class="search-history-left">
                    <span class="material-symbols-rounded">history</span>
                    <span class="search-history-text">${escapeHtml(term)}</span>
                </div>
                <button class="search-history-del-btn" data-term="${escapeHtml(term)}" onclick="removeSearchHistory(this, event)" aria-label="Xóa">
                    <span class="material-symbols-rounded">close</span>
                </button>
            </div>
        `).join('');

        historySection = `
            <div class="search-section-block">
                <div class="search-section-header">
                    <div class="search-section-title">
                        <span class="material-symbols-rounded">history</span>
                        <span>${t('search_history')}</span>
                    </div>
                    <button class="search-clear-all-btn" onclick="clearAllSearchHistory(event)">${t('search_clear_all')}</button>
                </div>
                <div class="search-history-list">
                    ${historyItems}
                </div>
            </div>
        `;
    }

    const topicChips = POPULAR_SEARCH_TOPICS.map(tp => renderSearchTopicChip(tp, false)).join('');
    const featuredItems = getFeaturedSuggestions();
    const featuredCards = featuredItems.map(item => renderFeaturedCardHTML(item, false)).join('');

    containerEl.innerHTML = `
        <div class="search-dropdown-body search-dropdown-empty-2col">
            <div class="search-empty-col-left">
                ${historySection}
                <div class="search-section-block">
                    <div class="search-section-header">
                        <div class="search-section-title">
                            <span class="material-symbols-rounded">trending_up</span>
                            <span>${t('search_trending_title')}</span>
                        </div>
                    </div>
                    <div class="search-chips-wrap">
                        ${topicChips}
                    </div>
                </div>
            </div>
            <div class="search-empty-col-right">
                <div class="search-section-block">
                    <div class="search-section-header">
                        <div class="search-section-title">
                            <span class="material-symbols-rounded">auto_awesome</span>
                            <span>${t('search_featured')}</span>
                        </div>
                    </div>
                    <div class="ms-featured-list">
                        ${featuredCards}
                    </div>
                </div>
            </div>
        </div>
    `;
}


